var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fruit",
    clipPath: "url(#clip0_774_72310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9353 3.91359C12.0249 3.94346 12.1139 3.97659 12.2015 4.01295C11.9288 4.66758 11.3352 5.19622 10.5708 5.46574C9.85058 5.71967 8.83746 5.78721 8.02826 5.48522C7.9802 5.16245 8.43546 4.73448 8.64847 4.50717C8.94267 4.19285 9.31934 3.95515 9.79213 3.83241C10.4559 3.65966 11.2274 3.68044 11.9359 3.91359H11.9353Z",
    fill: "#4E842E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2928 0.687834C10.3591 0.739789 10.7624 0.930723 10.8286 0.982678C9.1206 2.78291 7.89512 5.22609 8.04319 7.60756C8.02566 7.40104 7.79316 7.99008 7.78082 7.76538C7.71653 6.65354 7.88928 4.73316 8.2588 3.78759C8.66795 2.7407 9.44662 1.43468 10.2156 0.625488C10.2415 0.64627 10.2675 0.666403 10.2935 0.687185L10.2928 0.687834Z",
    fill: "#AB6D4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5974 13.5051C15.087 15.7307 13.2796 19.6234 10.5526 19.6293C9.9311 19.6306 9.31284 19.5163 8.69133 19.5455C8.05359 19.5754 7.47689 19.8209 6.85603 19.9417C4.97656 20.3086 3.34193 18.8448 2.27881 17.4725C0.820178 15.5898 -0.153325 13.1375 0.285043 10.7099C0.69094 8.46419 2.27621 6.28858 4.64145 5.921C5.66301 5.76189 6.65925 6.06647 7.6925 6.08466C9.1823 6.11064 10.728 5.43328 12.171 5.70604C13.7823 6.01062 14.9097 7.69006 15.4143 9.1357C15.9111 10.5586 15.928 12.0653 15.5974 13.5051Z",
    fill: "#D50328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.31335 7.93358C2.49052 8.44468 1.9911 9.4643 1.78004 10.3858C1.67028 10.8658 1.62547 11.3632 1.643 11.8549C1.65729 12.2718 1.71704 12.9362 2.04955 13.231C2.19178 13.357 2.37427 13.2537 2.42363 13.0979C2.48662 12.8985 2.42298 12.6459 2.41388 12.4374C2.40544 12.2367 2.38726 12.0367 2.38206 11.8354C2.37102 11.3944 2.42687 10.9541 2.53273 10.5261C2.74704 9.66043 3.18281 8.95124 3.5978 8.17322C3.69327 7.99333 3.46727 7.83746 3.31335 7.93293V7.93358Z",
    fill: "#FF6E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.4408 11.1931C14.307 11.0567 14.0771 11.0645 13.9686 11.2307C13.7602 11.5516 13.7628 11.836 13.7108 12.2081C13.6563 12.5972 13.5991 12.9946 13.5153 13.3784C13.3497 14.1383 13.0886 14.8929 12.7626 15.5988C12.4691 16.2353 12.1515 16.8561 11.8268 17.4777C11.7424 17.6394 11.6638 17.8543 11.7898 17.9868C11.9281 18.1329 12.1723 18.0323 12.336 17.9154C13.0354 17.4173 13.5459 16.7626 13.9186 15.9969C14.2921 15.23 14.5694 14.4513 14.7239 13.6109C14.8577 12.8829 15.0032 11.7652 14.4414 11.1924L14.4408 11.1931Z",
    fill: "#BA0323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.29244 0.451417C2.2801 0.301398 2.27556 0.151378 2.27816 5.99728e-05C3.70367 -0.0304635 5.13372 0.485837 6.21048 1.41972C7.2249 2.29971 8.11073 3.72652 8.15359 5.09812C7.58859 5.37803 6.44818 4.99681 5.86434 4.83575C5.05839 4.61365 4.33167 4.22139 3.74848 3.61611C2.92889 2.7647 2.38791 1.63144 2.29244 0.450768V0.451417Z",
    fill: "#6C9728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.37427 4.49677C7.26971 4.33246 7.09631 4.30129 6.92096 4.25907C6.70016 4.20647 6.48 4.15321 6.26309 4.08567C5.83706 3.95254 5.42597 3.75706 5.04605 3.51807C4.2901 3.04268 3.53806 2.34389 3.0854 1.55677C3.0302 1.46131 2.86914 1.54573 2.91655 1.64769C3.12956 2.10814 3.35102 2.56924 3.67963 2.95566C4.00435 3.33687 4.36739 3.66679 4.77978 3.94475C5.19217 4.2227 5.63184 4.44676 6.09943 4.60912C6.44363 4.72861 7.06579 4.978 7.36778 4.67601C7.41324 4.63055 7.40739 4.54807 7.37492 4.49677H7.37427Z",
    fill: "#4E842E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_774_72310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6416,
    height: 20,
    fill: "white",
    transform: "translate(0.179184 -0.0012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c4d1f1aae1f3589c189d5c60218bca9a.svg";
export { ForwardRef as ReactComponent };